import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "tournaments-selection",
  "data-qe-id": "tournaments-selection-tab-bar"
}
const _hoisted_2 = ["onClick", "data-qe-id"]


export interface TournamentsSelections {
  tournamentId: string
  name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CTournamentsSelection',
  props: {
    tournamentsSelections: {},
    selectedTId: {}
  },
  emits: ['action'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tournamentsSelections, (id) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (emit('action', id.tournamentId)),
        key: id.tournamentId,
        class: _normalizeClass(["t-item", _ctx.selectedTId === id.tournamentId ? 'active' : '']),
        "data-qe-id": `tournaments-selection-tab--${id.tournamentId}`
      }, _toDisplayString(id.name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})